module.exports = __webpack_public_path__ + "static/media/contact.f44435d5.jpg";